<app-loading
    [observable]="viewModel$"
>
    <ng-container
        *ngIf="!hasRedirectedToStorefront && (viewModel$ | async) as viewModel"
    >
        @let landingPage = viewModel.landingPage;
        @if (viewModel.venue && (viewModel.venue.shouldUseVenueStorefrontExperience()
            || viewModel.launchParams.setupBookingRequestId || viewModel.launchParams.paymentIntentId || viewModel.launchParams.setupIntentId)) {
            <app-venue-storefront
                [venue]="viewModel.venue"
                [initialBookingSearch]="viewModel.launchParams"
                [setupBookingRequestId]="viewModel.launchParams.setupBookingRequestId ?? null"
                [setupCancelled]="viewModel.launchParams.setupCancelled ?? false"
                [paymentIntentId]="viewModel.launchParams.paymentIntentId ?? null"
                [setupIntentId]="viewModel.launchParams.setupIntentId ?? null"
                [voucherStorefrontPath]="viewModel.voucherStorefrontPath"
            />
        } @else {
            <div class="vh-100 vstack gap-3 gap-lg-4 bg-light">
            <div>
                <nav class="navbar bg-body shadow-sm">
                    <div class="container-fluid justify-content-center">
                        <a class="navbar-brand fw-semibold">
                            {{ landingPage.displayName }}
                        </a>
                    </div>
                </nav>
                <hr class="my-0 border border-light-subtle">
            </div>
            <div class="container vstack gap-4">
                <div class="row">
                    <div class="offset-md-2 offset-lg-3 col-12 col-md-8 col-lg-6">
                        <div class="vstack gap-3">
                            <div class="card vstack gap-4">
                                <div class="p-3 vstack gap-3">
                                    <div class="px-2 vstack flex-grow-0 gap-2">
                                        <h5 class="m-0 fw-semibold">
                                            {{ landingPage.displayName }}
                                        </h5>
                                    </div>
                                    <hr class="my-0 border">
                                    <div class="px-1 px-lg-2 vstack gap-3 text-secondary">
                                        <div class="vstack gap-2">
                                            <div class="hstack gap-2">
                                                <img
                                                    ngSrc="assets/location.svg"
                                                    class="icon"
                                                    width="20"
                                                    height="20"
                                                    alt="Location"
                                                >
                                                {{ landingPage.address | addressString }}
                                            </div>
                                            @if (landingPage.phoneNumber) {
                                                <div class="hstack gap-2">
                                                    <img
                                                        ngSrc="assets/phone.svg"
                                                        class="icon"
                                                        width="20"
                                                        height="20"
                                                        alt="Phone"
                                                    >
                                                    <a
                                                        [href]="'tel:' + landingPage.phoneNumber"
                                                        class="link-secondary"
                                                    >
                                                        {{ landingPage.phoneNumber }}
                                                    </a>
                                                </div>
                                            }
                                            <div
                                                *ngIf="landingPage.emailAddress"
                                                class="hstack gap-2"
                                            >
                                                <img
                                                    ngSrc="assets/email.svg"
                                                    class="icon"
                                                    width="20"
                                                    height="20"
                                                    alt="Email"
                                                >
                                                <a
                                                    [href]="'mailto:' + landingPage.emailAddress"
                                                    class="link-secondary"
                                                >
                                                    {{ landingPage.emailAddress }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    @if (landingPage.inService && viewModel.bookingContext) {
                                        <button
                                            appVenueColour
                                            [primaryColour]="viewModel.venueColour"
                                            class="btn btn-lg btn-primary w-100"
                                            type="button"
                                            data-testid="landing-book-now"
                                            style="height: 48px;"
                                            (click)="openBookingModal(viewModel.bookingContext)"
                                        >
                                            Book Now
                                        </button>
                                    } @else {
                                        <div
                                            class="alert alert-light border border-light-subtle mb-0"
                                            role="status"
                                        >
                                            <p class="fw-semibold mb-1">
                                                This venue is not currently available on TableSense.
                                            </p>
                                            <p class="mb-0 text-secondary">
                                                To enquire about a booking, please get in touch with the venue directly.
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div
                                *ngIf="mapUrl$ | async as mapUrl"
                                class="card"
                            >
                                <div class="vstack gap-2">
                                    <iframe
                                        class="w-100 rounded"
                                        height="300"
                                        style="border:0"
                                        loading="lazy"
                                        allowfullscreen
                                        referrerpolicy="no-referrer-when-downgrade"
                                        [src]="mapUrl | safeURL"
                                    >
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p
                    class="text-muted text-center mt-auto"
                >
                    Powered by
                    <a
                        class="link-primary"
                        [href]="marketingUrl"
                        target="_blank"
                    >
                        TableSense
                    </a>
                </p>
            </div>
            </div>
        }
    </ng-container>
</app-loading>
